import { CreditCard, FileText } from "lucide-react";

const OPTIONS = [
  { key: "card", label: "Pay by Card", hint: "Secure checkout via Stripe", icon: CreditCard },
  { key: "check", label: "Check / Invoice", hint: "We'll send payment instructions", icon: FileText },
];

export const PaymentMethod = ({ value, onChange, prefix, compact = false }) => (
  <div data-testid={`${prefix}-payment-method`}>
    <label className="label-font text-[11px] text-espresso/70">Payment Method</label>
    <div className={`mt-3 grid grid-cols-2 ${compact ? "gap-2" : "gap-3"}`}>
      {OPTIONS.map((o) => {
        const on = value === o.key;
        return (
          <button
            key={o.key}
            type="button"
            data-testid={`${prefix}-payment-method-${o.key}`}
            aria-pressed={on}
            onClick={() => onChange(o.key)}
            className={`text-left border p-3.5 flex items-start gap-3 transition-colors ${
              on ? "border-rust bg-rust/10" : "border-border bg-transparent hover:border-rust/60"
            }`}
          >
            <span className={`h-8 w-8 flex items-center justify-center shrink-0 ${on ? "bg-rust text-primary-foreground" : "bg-espresso/10 text-espresso"}`}>
              <o.icon size={15} />
            </span>
            <span className="min-w-0">
              <span className="block label-font text-[11px] text-espresso">{o.label}</span>
              <span className="block text-xs text-muted-foreground mt-0.5 leading-snug">{o.hint}</span>
            </span>
          </button>
        );
      })}
    </div>
  </div>
);
